import React from 'react';
import PdfViewer from './PdfViewer';

const DECK_URL = 'https://global.divhunt.com/692fb2f55bd53f0e3570cbbf494cd801_2881955.pdf';

export default function SalesDeck() {
  return (
    <PdfViewer
      eyebrow="Sales deck"
      title="Present with confidence."
      intro="Our sales deck for client meetings. View it here, open it full screen, or download a copy."
      url={DECK_URL}
      frameTitle="Jelly Local sales deck"
    />
  );
}